import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./product-details.scss";

export default function ProductDetails({ host }) {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [loading, setLoading] = useState(true);

  // fullscreen modal states
  const [fullscreen, setFullscreen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetch(`${host}/api/shop/motorcycles/${id}/`)
      .then((res) => res.json())
      .then((data) => {
        const gallery =
          data.images?.map((img) =>
            img.startsWith("http") ? img : `${host}${img}`
          ) || [];

        const fullGallery = [data.main_image, ...gallery].map((img) =>
          img.startsWith("http") ? img : `${host}${img}`
        );

        setProduct({ ...data, images: fullGallery });
        setMainImage(fullGallery[0]);
      })
      .finally(() => setLoading(false));
  }, [id, host]);

  if (loading) return <p>Ładowanie danych...</p>;
  if (!product) return <p>Nie znaleziono motocykla</p>;

  const {
    title,
    description,
    price,
    country,
    mileage,
    production_year,
    body_type,
    engine_capacity,
    power,
    license_category,
    images,
  } = product;

  const descList = description
    .split(/[\n•\-]+/)
    .map((item) => item.trim())
    .filter(Boolean);

  const openFullscreen = (index) => {
    setCurrentIndex(index);
    setFullscreen(true);
  };

  const prevImg = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImg = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <motion.div
        className="details-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="gallery">
          <motion.img
            key={mainImage}
            src={mainImage}
            className="main-image"
            onClick={() => openFullscreen(currentIndex)}
            initial={{ opacity: 0.6, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
          />

          <div className="thumbs">
            {images?.map((img, idx) => (
              <motion.img
                key={idx}
                src={img}
                onClick={() => {
                  setMainImage(img);
                }}
                className={`thumb ${img === mainImage ? "active" : ""}`}
                whileHover={{ scale: 1.05 }}
              />
            ))}
          </div>
        </div>

        <aside className="details-content">
          <div className="specs-box">
            <ul>
              <li>
                <span>Cena:</span> <strong>{price.toLocaleString()} PLN</strong>
              </li>
              <li>
                <span>Kraj:</span> <strong>{country}</strong>
              </li>
              <li>
                <span>Przebieg:</span> <strong>{mileage} km</strong>
              </li>
              <li>
                <span>Rok produkcji:</span> <strong>{production_year}</strong>
              </li>
              <li>
                <span>Typ nadwozia:</span> <strong>{body_type}</strong>
              </li>
              <li>
                <span>Pojemność:</span> <strong>{engine_capacity} cc</strong>
              </li>
              <li>
                <span>Moc:</span> <strong>{power} KM</strong>
              </li>
              <li>
                <span>Prawo jazdy:</span> <strong>{license_category}</strong>
              </li>
            </ul>
          </div>

          <h1>{title}</h1>

          <ul className="desc-list">
            {descList.map((item, idx) => (
              <motion.li
                key={idx}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: idx * 0.07 }}
              >
                {item}
              </motion.li>
            ))}
          </ul>
        </aside>
      </motion.div>

      {/* ✅ FULLSCREEN IMAGE MODAL */}
      <AnimatePresence>
        {fullscreen && (
          <motion.div
            className="fullscreen-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setFullscreen(false)}
          >
            <motion.img
              key={currentIndex}
              src={images[currentIndex]}
              className="fullscreen-image"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            />

            <button className="nav-btn prev" onClick={prevImg}>
              ❮
            </button>

            <button className="nav-btn next" onClick={nextImg}>
              ❯
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
